import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "@components/ScrollToTop";
import ErrorBoundary from "@components/ErrorBoundary";
// Add your imports here
import HomepagePremiumHealthcareDigitalExperience from "./pages/homepage-premium-healthcare-digital-experience";
import AboutOurStoryMedicalPhilosophy from "@pages/about-our-story-medical-philosophy";
import OurTeamExpertNetworkPersonalConnections from "@pages/our-team-expert-network-personal-connections";
import LocationsCommunityHealthHubNetwork from "@pages/locations-community-health-hub-network";
import ServicesComprehensiveEyeCareUniverse from "@pages/services-comprehensive-eye-care-universe";
import ContactMultiChannelCommunicationHub from "@pages/contact-multi-channel-communication-hub";
import BookAppointmentGuidedCareJourney from "@pages/book-appointment-guided-care-journey";
import CareerPage from "@pages/career-page";
import FAQsPage from "@pages/fa-qs-page";
import PatientResourcesPage from "@pages/patient-resources-page";
import NotFound from "@pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<HomepagePremiumHealthcareDigitalExperience />} />
        <Route path="/homepage-premium-healthcare-digital-experience" element={<HomepagePremiumHealthcareDigitalExperience />} />
        <Route path="/about-our-story-medical-philosophy" element={<AboutOurStoryMedicalPhilosophy />} />
        <Route path="/our-team-expert-network-personal-connections" element={<OurTeamExpertNetworkPersonalConnections />} />
        <Route path="/locations-community-health-hub-network" element={<LocationsCommunityHealthHubNetwork />} />
        <Route path="/services-comprehensive-eye-care-universe" element={<ServicesComprehensiveEyeCareUniverse />} />
        <Route path="/book-appointment-guided-care-journey" element={<BookAppointmentGuidedCareJourney />} />
        <Route path="/career-page" element={<CareerPage />} />
        <Route path="/fa-qs-page" element={<FAQsPage />} />
        <Route path="/patient-resources-page" element={<PatientResourcesPage />} />
        <Route path="/contact-multi-channel-communication-hub" element={<ContactMultiChannelCommunicationHub />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;